import styled from 'styled-components'


const ButtonCreateDebateBigStyle = styled.div.attrs(props => ({ className: props.className }))`
    border:2px dashed var(--purple);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding:4px var(--spSize);
    height: 100%;
    border-radius: 15px;
    transition:var(--trTime);

    &.in-slider {
        min-width:var(--sp24x);
    }

    &:hover {
        border:2px solid var(--purple);
        background-color:var(--purple) ;

        .circle {
            background-color: var(--white);

            i:before {
                color:var(--purple);
            }

        }
        .comp-title {
            color:var(--white);
        }
    }

    &.profile {
        max-width: var(--sp52x);
        min-height: var(--sp48x);
        width:100%;
        margin-top:var(--sp4x);
    }

    .circle {
        width: var(--sp6x);
        height: var(--sp6x);
        background-color: var(--purple);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: var(--sp2x);

        i {
            font-size: 15px;
        }
    }

    @media only screen and (max-width: ${(props) => props.theme.mediaQuery.MobileSize}){
        .circle {
            width: var(--sp4x);
            height: var(--sp4x);
            margin-bottom: 0;

            i {
                font-size: 14px;
            }
        }
        
        .comp-title:not(.circle){
            display: none;
        }
    }
`
export default ButtonCreateDebateBigStyle
